/* eslint-disable standard/object-curly-even-spacing */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { trackingEnvironment } from '@xingternal/content-tracking';

import Message from '@xingternal/malt-message';
import { Card } from '@xingternal/card';
import { Paragraph } from '@xingternal/malt-typography';

const renderTextBlock = (message) =>
  message &&
  message.split('\n').map((line) => (
    <Fragment key={line}>
      {line}
      <br />{' '}
    </Fragment>
  ));

const renderViolations = (errors) =>
  errors &&
  errors.map((message) => (
    <li
      key={message}
      style={{ fontFamily: 'monospace' /* stylelint-disable-line */ }}
    >
      {renderTextBlock(message)}
    </li>
  ));

const renderGraphqlErrors = (errors) =>
  errors &&
  errors.map(({ details, message }, i) => (
    <Card role="listitem" key={i}>
      <header>
        <strong>{message}</strong>
      </header>
      <div>{renderTextBlock(details.message)}</div>
      <footer>
        <Paragraph level={3}>{details.type}</Paragraph>
      </footer>
    </Card>
  ));

const renderNetworkErrors = (errors) =>
  errors &&
  errors.map(({ details, message }, i) => (
    <Card role="listitem" key={i}>
      <header>
        <strong>{message}</strong>
      </header>
      <div>
        <ul>{renderViolations(details.violations)}</ul>
      </div>
    </Card>
  ));

const ErrorGraphql = ({ title, error, className }) => {
  if (trackingEnvironment === 'production' || error == null) {
    return null;
  }

  const { graphQLErrors } = error;
  const networkErrors = error?.networkError?.result?.errors;

  return (
    <Fragment>
      <Message headline={`${title} Error`} type="error" className={className}>
        {error.message}
      </Message>
      {graphQLErrors && renderGraphqlErrors(graphQLErrors)}
      {networkErrors && renderNetworkErrors(networkErrors)}
    </Fragment>
  );
};

ErrorGraphql.propTypes = {
  title: PropTypes.string,
  error: PropTypes.object,
  className: PropTypes.string,
};

ErrorGraphql.defaultProps = {
  title: '',
};

export default ErrorGraphql;
